import { CookieService } from './../../../../shared/services/cookie/cookie.service';
import { EventsService } from './../../../../shared/services/events/events.service';
import { UtilService } from './../../../../shared/services/util/util.service';
import { Subscription } from 'rxjs';
import { VariablesService } from './../../../../shared/services/variables/variables.service';
import { Component, OnInit } from '@angular/core';
import { VwoService } from '../../../../shared/services';

@Component({
  selector: 'app-sip-top-banner',
  templateUrl: './sip-top-banner.component.html',
  styleUrls: ['./sip-top-banner.component.scss']
})
export class SipTopBannerComponent implements OnInit {

  constructor(
    public utilService: UtilService,
    public vars: VariablesService,
    private eventsService: EventsService,
    private cookieService: CookieService,
    public vwo: VwoService
  ) { }
  subs: Subscription[] = [];
  isSipSubscribed = false;
  isAppUser = '';
  isMobile;
  isIos;

  ngOnInit() {
    this.isMobile = this.utilService.isMobile();
    this.isIos = this.utilService.isIOSDevice();
    this.vars.userData.subscribe({
      next: (res) => {
        this.isSipSubscribed = [1, 2].includes(res?.listsubscriptions?.medical?.status_flag);
      }
    });

    this.isAppUser = this.cookieService.getCookie('platform');
  }
  openUrl() {
    this.systemEvent();
    if (this.isAppUser) {
      this.utilService.nativeNavigation('https://sipketto.page.link/4Mnz');
    }
  }

  systemEvent() {
    const payload: any = {
      eventName: 'download_app_banner',
      page_name: this.vars.pageName
    };
    this.eventsService.sendSystemEvent(payload).subscribe(_ => _);
  }
}
